var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef, useMemo } from "react";
import { Canny, CannyLoader } from "../../makes";
import { CannyContext } from "../../contexts";
const CannyProvider = (props) => {
    const { children, appId } = props;
    const [isLoaded, setLoaded] = useState(false);
    const refCanny = useRef(null);
    const canny = useMemo(() => {
        return new Canny(refCanny.current);
    }, [isLoaded]);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const loader = new CannyLoader();
            try {
                refCanny.current = yield loader.load();
                setLoaded(true);
            }
            catch (err) {
                console.error(err);
            }
        }))();
    }, []);
    return (_jsx(CannyContext.Provider, Object.assign({ value: {
            appId,
            isLoaded,
            canny
        } }, { children: children }), void 0));
};
export { CannyProvider };
